import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
// import { Button } from '@/components/ui/button';
// import { div , div Header, div Row, div , div Body } from '@/components/ui/div ';
// import { input } from '@/components/ui/input';
// import { Card, CardContent } from '@/components/ui/card';
import * as XLSX from 'xlsx';
import Empty from '../../utils/Empty';
import { Table } from 'react-bootstrap';
import Footer from '../../Footer/Footer';
// import jsPDF from 'jspdf';
// import 'jspdf-autodiv ';

const BankReconciliation = () => {
    //--------------------------------------------------
    const [show, setShow] = useState(false)
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    //--------------------------------------------------

    //--------------------------------------------------
    const [bankMovements, setBankMovements] = useState([]);
    const [reconciliationStatus, setReconciliationStatus] = useState([]);
    const [filter, setFilter] = useState({ bank: '', startDate: '', endDate: '' });
    const [history, setHistory] = useState([]);

    const [selectedMovement, setSelectedMovement] = useState(null);
    const [lotData, setLotData] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);

    const handleBankFileUpload = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = (evt) => {
            const bstr = evt.target.result;
            const wb = XLSX.read(bstr, { type: 'binary' });
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            const data = XLSX.utils.sheet_to_json(ws);
            setBankMovements(data);
            setReconciliationStatus(data.map(() => 'En Proceso'));
        };
        reader.readAsBinaryString(file);

        if (e.target.files.length > 0) {
            setFileName(e.target.files[0].name);
        } else {
            setFileName('No hay ningún archivo seleccionado');
        }
    };

    const handleRowClick = (movement, index) => {
        setSelectedMovement({ movement, index });
        setLotData([]);
        setModalOpen(true);
    };
    //--------------------------------------------------
    const handleLotFileUpload = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = (evt) => {
            const bstr = evt.target.result;
            const wb = XLSX.read(bstr, { type: 'binary' });
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            const lot = XLSX.utils.sheet_to_json(ws);
            setLotData(lot);

            const { movement, index } = selectedMovement;
            const matched = lot.some(l =>
                l.Monto === movement.Credito &&
                l.Fecha === movement.Fecha &&
                l.Referencia === movement.Referencia
            );

            const newStatus = [...reconciliationStatus];
            newStatus[index] = matched ? 'Pagado' : 'En Proceso';
            setReconciliationStatus(newStatus);
        };
        reader.readAsBinaryString(file);
    };

    const handleManualReconciliation = (index) => {
        const newStatus = [...reconciliationStatus];
        newStatus[index] = 'Pagado';
        setReconciliationStatus(newStatus);

        const newHistory = [...history, {
            movimiento: bankMovements[index],
            fecha: new Date().toLocaleString(),
            usuario: 'UsuarioActual'
        }];
        setHistory(newHistory);
    };

    // const exportPDF = () => {
    //     const doc = new jsPDF();
    //     doc.text('Reporte de Conciliación Bancaria', 20, 10);
    //     const div = bankMovements.map((movement, i) => [
    //         movement.Fecha,
    //         movement.Descripcion,
    //         movement.Debito || '',
    //         movement.Credito || '',
    //         movement.Referencia,
    //         reconciliationStatus[i]
    //     ]);
    //     doc.autodiv ({
    //         head: [['Fecha', 'Descripción', 'Débito', 'Crédito', 'Referencia', 'Estado']],
    //         body: div
    //     });
    //     doc.save('conciliacion.pdf');
    // };

    const filteredMovements = bankMovements.filter(movement => {
        const movementDate = new Date(movement.Fecha);
        const startDate = filter.startDate ? new Date(filter.startDate) : null;
        const endDate = filter.endDate ? new Date(filter.endDate) : null;

        return (
            (!filter.bank || movement.Banco === filter.bank) &&
            (!startDate || movementDate >= startDate) &&
            (!endDate || movementDate <= endDate)
        );
    });

    //Dropzone fILE
    const [fileName, setFileName] = useState('No hay ningún archivo seleccionado');

    const handleFileChange = (e) => {
        if (e.target.files.length > 0) {
            setFileName(e.target.files[0].name);
        } else {
            setFileName('No hay ningún archivo seleccionado');
        }
    };

    return (<>
        <div>


            <div>
                {/* <div className="space-y-4">
                    <h2 className="text-xl font-bold">Subir Estado de Cuenta Bancario</h2>
                    <input type="file" accept=".xlsx, .xls" onChange={handleBankFileUpload} />
                </div> */}

                <div className='d-flex justify-content-between align-items-center'>
                    <h5>
                        Conciliación Bancaria
                    </h5>
                    <div className='d-flex justify-content-end gap-2'>

                        {/* ----------------------------------------- */}
                        <div class="button-wrapper  " role='button' >
                            <button role='button' class="label  rounded-2 btn btn-primary " onClick={handleShow}>
                                Plantilla Bancaria
                            </button>

                            <input type="file" name="upload" id="upload"

                                className="upload-box" placeholder="Upload File"
                            />
                        </div>
                        <button className='btn btn-primary' onClick={handleShow}>
                            Subir Estado de Cuenta Bancario
                        </button>
                    </div>

                </div>


                <Modal show={show} onHide={handleClose} animation={true}>
                    <Modal.Body>
                        <div className=' position-relative'>
                            <div className='position-absolute top-0 start-100 translate-middle  '>
                                <div className='me-3'>
                                    <button class="btn btn-outline-secondary border-0 bg-light text-secondary rounded-circle p-2 lh-1" type="button" variant="secondary" onClick={handleClose} title='Cerrar'>
                                        <i class="uil uil-multiply"></i>
                                        <span class="visually-hidden">Dismiss</span>
                                    </button>
                                </div>
                            </div>
                            <h2 className="title-main-login  text-center  mt-lg-2">Importación de movimientos
                                <br />
                                bancario</h2>
                            <div className=" p-3 bg-white rounded-3 border mt-5">
                                <h6 className="fw-semibold">Subir Estado de Cuenta Bancario </h6>
                                <div className="dropzone-container">
                                    <label htmlFor="dropzone-file" className="dropzone-label">
                                        <div className="dropzone-content">
                                            <svg
                                                className="dropzone-icon"
                                                aria-hidden="true"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 20 16"
                                            >
                                                <path
                                                    stroke="currentColor"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                                                />
                                            </svg>
                                            <p className="dropzone-text">
                                                <span className="dropzone-bold">Haga clic para cargar archivo de Estado de Cuenta Bancario </span>
                                            </p>

                                            <p className="file-name">{fileName}</p>
                                        </div>
                                        <input
                                            id="dropzone-file"
                                            type="file"
                                            accept=".xlsx, .xls"
                                            className="dropzone-input"
                                            onChange={handleBankFileUpload}
                                        />
                                    </label>
                                </div>
                            </div>
                        </div>


                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={handleClose}>
                            Enviar
                        </Button>
                    </Modal.Footer>
                </Modal>


            </div>

            {bankMovements.length > 0 && (
                <>
                    <div className="row  mt-2 bg-white p-2 rounded-3 border">


                        {/* <div className='col-4'>
                            <label for="inputPassword5" class="form-label">Filtrar</label>
                            <input class="form-control"
                                placeholder="Filtrar por banco"
                                value={filter.bank}
                                onChange={(e) => setFilter({ ...filter, bank: e.target.value })}
                            />
                        </div> */}
                        <div className='col-6'>
                            <label for="inputPassword5" class="form-label">Fecha de inicio</label>
                            <input class="form-control"
                                type="date"
                                placeholder="Fecha inicio"
                                value={filter.startDate}
                                onChange={(e) => setFilter({ ...filter, startDate: e.target.value })}
                            />
                        </div>


                        <div className='col-6'>
                            <label for="inputPassword5" class="form-label">Fecha de fin</label>
                            <input class="form-control"
                                type="date"
                                placeholder="Fecha fin"
                                value={filter.endDate}
                                onChange={(e) => setFilter({ ...filter, endDate: e.target.value })}
                            />
                        </div>

                    </div>


                    <table className="table table-hover mt-5">
                        <thead >
                            <tr className="table-dark">
                                <th  >Estado</th >
                                <th   >Fecha</ th>
                                <th   >Descripción</ th>
                                <th  >Débito</th >
                                <th  >Crédito</th >
                                <th  >Referencia</th >
                                <th  >Subir Lote</th >
                                {/* <th  >Conciliación Manual</th > */}
                            </tr>
                        </thead>
                        <tbody>

                            {filteredMovements.map((movement, index) => (
                                <tr key={index}

                                    onClick={() => handleRowClick(movement, index)}
                                >

                                    <td    >
                                        {reconciliationStatus[index] === 'Pagado'
                                            ? <> <span className='text-on icon-on rounded-pill px-2'><i class="fa-solid fa-check"></i>Pagado</span></>
                                            : <><span className=' bg-secondary-subtle text-secondary rounded-pill px-2'><i class="fa-solid fa-spinner"></i> En Proceso</span></>
                                        }
                                    </td >
                                    <td > {movement.Fecha}</td >
                                    <td >{movement.Descripcion}</td >
                                    <td >{movement.Debito || ''}</td >
                                    <td >{movement.Credito || ''}</td >
                                    <td  >{movement.Referencia}</ td >

                                    <td  >
                                        {/* <input type="file" accept=".xlsx, .xls" onChange={(e) => handleLotFileUpload(e, index)} /> */}

                                        <button className=' text-primary rounded-3 px-2'>
                                            <i class="uil uil-file-upload-alt"></i> Subir lote
                                        </button>
                                    </td >
                                    {/* <td >
                                        <button className='btn btn-outline-secondary' onClick={() => handleManualReconciliation(index)}>Conciliar Manualmente</button>
                                    </td > */}
                                </tr >
                            ))}
                        </tbody>
                    </table>



                    {/* <Button onClick={exportPDF}>Exportar PDF</Button> */}
                </>
            )}


            {bankMovements.length === 0 && (<>
                <div className='mt-3' onClick={handleShow}>
                    <Empty title="Vacío" msg="Cargue un archivo de movimientos o estados bancarios para conciliar." />
                </div>
            </>)}

            {/* 
//Modal Info line */}

            <Modal size="xl" show={modalOpen} onHide={() => setModalOpen(false)} animation={true}>
                <Modal.Body>
                    <div className=' position-relative'>
                        <div className='position-absolute top-0 start-100 translate-middle  '>
                            <div className='me-3'>
                                <button class="btn btn-outline-secondary border-0 bg-light text-secondary rounded-circle p-2 lh-1" type="button" variant="secondary" onClick={() => setModalOpen(false)} title='Cerrar'>
                                    <i class="uil uil-multiply"></i>
                                    <span class="visually-hidden">Dismiss</span>
                                </button>
                            </div>
                        </div>
                        <h2 className="title-main-login  text-center  mt-lg-2"> <i class="fa-solid fa-money-bill-transfer"></i> Importación de Lotes</h2>
                        <div className=" p-3 bg-white rounded-3 border mt-2">
                            <section >
                                {selectedMovement && (
                                    <div className="">
                                        <div className=' w-100  m-1 p-2 '>
                                            <div className='d-flex justify-content-between align-items-center mb-2'>
                                                <h6 className="fw-semibold"> Movimiento Bancario</h6>


                                                <button className="fw-semibold btn btn-success">Guardar Movimiento Bancario</button>

                                            </div>

                                            <div class="card border border-success-subtle border-2 " role='button' >
                                                <div class="card-body">
                                                    <div class="d-flex justify-content-between">
                                                        <div class="flex-column align-items-center">
                                                            <h5 class="card-text">{selectedMovement.movement.Descripcion}</h5>
                                                            <h6 class="card-subtitle mb-2 text-body-secondary">Referencia: {selectedMovement.movement.Referencia}</h6>
                                                        </div>
                                                        <div>
                                                            {!selectedMovement.movement.Debito ? "" : <span className='text-off'><span>Débito: -${selectedMovement.movement.Debito || 0} </span> </span>}
                                                            {!selectedMovement.movement.Credito ? "" : <span className='text-on fw-semibold' ><span >Crédito: ${selectedMovement.movement.Credito || 0} </span> </span>}

                                                        </div>

                                                    </div>

                                                    <p class="card-text">Fecha:{selectedMovement.movement.Fecha}</p>

                                                </div>
                                            </div>
                                        </div>

                                        <div className='border-3'>
                                            {/* <input type="file" accept=".xlsx, .xls" onChange={handleLotFileUpload} /> */}

                                            <div className='d-flex justify-content-end gap-2'>
                                                {/* ----------------------------------------- */}
                                                <div class="button-wrapper  " role='button' >
                                                    <button role='button' class="label  rounded-2 btn btn-primary ">
                                                        Subir lote
                                                    </button>

                                                    <input type="file" name="upload" id="upload"
                                                        accept=".xlsx, .xls" onChange={handleLotFileUpload}
                                                        className="upload-box" placeholder="Upload File"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className=" d-flex justify-content-between">
                                            <div className='w-50'>
                                                <h6 className="fw-semibold"> Transacciones Registradas</h6>

                                                {/* <div class="card border border-success-subtle border-2 " role='button' >
                                                    <div class="card-body">
                                                        <div class="d-flex justify-content-between">
                                                            <div class="flex-column align-items-center">
                                                                <h5 class="card-text">{selectedMovement.movement.Descripcion}</h5>
                                                                <h6 class="card-subtitle mb-2 text-body-secondary">Referencia: {selectedMovement.movement.Referencia}</h6>
                                                            </div>
                                                            <div>
                                                                {!selectedMovement.movement.Debito ? "" : <span className='text-off'><span>Débito: -${selectedMovement.movement.Debito || 0} </span> </span>}
                                                                {!selectedMovement.movement.Credito ? "" : <span className='text-on fw-semibold' ><span >Crédito: ${selectedMovement.movement.Credito || 0} </span> </span>}

                                                            </div>

                                                        </div>

                                                        <p class="card-text">Fecha:{selectedMovement.movement.Fecha}</p>

                                                    </div>
                                                </div> */}
                                            </div>
                                            <div className='w-50'>
                                                <h6 className="fw-semibold"> Conciliación</h6>
                                                {/* <div class=" card border-0 position-relative" role='button'  >
                                                    <div class="card-body border-dashed border-secondary rounded-2 bg-white">
                                                        <div class="d-flex justify-content-between">
                                                            <div class="flex-column align-items-center">
                                                                <h5 class="card-title">{selectedMovement.movement.Descripcion}</h5>
                                                                <h6 class="card-subtitle mb-2 text-body-secondary">Referencia: {selectedMovement.movement.Referencia}</h6>
                                                            </div>
                                                            <div>
                                                                {!selectedMovement.movement.Debito ? "" : <span className='text-off'><span>Débito: -${selectedMovement.movement.Debito || 0} </span> </span>}
                                                                {!selectedMovement.movement.Credito ? "" : <span className='text-on fw-semibold' ><span >Crédito: ${selectedMovement.movement.Credito || 0} </span> </span>}

                                                            </div>

                                                        </div>

                                                        <p class="card-text">Fecha:{selectedMovement.movement.Fecha}</p>

                                                    </div>
                                                    <div className='position-absolute top-0 start-100 translate-middle  '>
                                                        <div className='me-3'>
                                                            <button class="btn btn-light rounded-circle p-2 lh-1 bg-body text-dark border" type="button" variant="secondary" title='Cerrar'>
                                                                <i class="uil uil-minus"></i>
                                                                <span class="visually-hidden">Dismiss</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                        {lotData.length > 0 && (

                                            <div className='wrapper-bank p-2'>
                                                <div className='d-flex justify-content-around p-0 px-0 py-0'>
                                                    <div className='col-6 m-0 '>
                                                        {lotData.map((lot, idx) => (
                                                            <div className=' p-2  position-relative text-on icon-on' key={idx}>
                                                                <div class="card border-0 " role='button'  >
                                                                    <div class="card-body ">
                                                                        <div class="d-flex justify-content-between">
                                                                            <div class="flex-column align-items-center">
                                                                                <h5 class="card-title">{lot.Descripcion}</h5>
                                                                                <h6 class="card-subtitle mb-2 text-body-secondary">Referencia: {lot.Referencia}</h6>
                                                                            </div>
                                                                            <div>
                                                                                {!lot.Debito ? "" : <span className='text-off'><span>Débito: -${lot.Debito || 0} </span> </span>}
                                                                                {!lot.Credito ? "" : <span className='text-on fw-semibold' ><span >Crédito: ${lot.Credito || 0} </span> </span>}

                                                                            </div>
                                                                        </div>
                                                                        <p class="card-text">Fecha:{lot.Fecha}</p>
                                                                    </div>
                                                                </div>
                                                                <div className='position-absolute bottom-0 end-0 '>
                                                                    <div className='mt-2'>
                                                                        <span class=" rounded-3 p-1 lh-1 text-on icon-on  border-0" type="button" variant="secondary" title=''>
                                                                            <i class="uil uil-check-circle"></i> Transacción encontrada
                                                                            <span class="visually-hidden">Dismiss</span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>

                                                    <div className='col-6 m-0 '>
                                                        {lotData.map((lot, idx) => (
                                                            <div className='border-dashed  position-relative p-2' key={idx}>
                                                                <div class="card border-0" role='button'  >
                                                                    <div class="card-body bg-white">
                                                                        <div class="d-flex justify-content-between">
                                                                            <div class="flex-column align-items-center">
                                                                                <h5 class="card-title">{lot.Descripcion}</h5>
                                                                                <h6 class="card-subtitle mb-2 text-body-secondary">Referencia: {lot.Referencia}</h6>
                                                                            </div>
                                                                            <div>
                                                                                {!lot.Debito ? "" : <span className='text-off'><span>Débito: -${lot.Debito || 0} </span> </span>}
                                                                                {!lot.Credito ? "" : <span className='text-secondary fw-semibold' ><span >Crédito: ${lot.Credito || 0} </span> </span>}

                                                                            </div>
                                                                        </div>
                                                                        <p class="card-text">Fecha:{lot.Fecha}</p>
                                                                    </div>
                                                                </div>
                                                                <div className='position-absolute top-0 end-0 '>
                                                                    <div className=''>
                                                                        <button class="btn btn-light rounded-3 p-1 lh-1 border" type="button" variant="secondary" title='Cerrar'>
                                                                            <i class="uil uil-minus"></i>
                                                                            <span class="visually-hidden">Dismiss</span>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {

                                            lotData.length ===
                                            0 && (<>

                                                <Empty title="Vacío" msg="No se ha cargado ningún archivo con lotes para conciliar" onChange={handleLotFileUpload} />
                                            </>)
                                        }
                                    </div>
                                )}
                            </section>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setModalOpen(false)}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>

            {history.length > 0 && (
                <div>
                    <div>
                        <h3 className="text-lg font-bold">Historial de Conciliaciones</h3>
                        <ul>
                            {history.map((item, idx) => (
                                <li key={idx}>
                                    {item.fecha} - {item.movimiento.Descripcion} - {item.usuario}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}

        </div >


        {/* Modal de Plantilla Bancaria */}
        {/* <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Modal heading</Modal.Title>
            </Modal.Header>
            <Modal.Body>Woohoo, you are reading this text in a modal!</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={handleClose}>
                    Save Changes
                </Button>
            </Modal.Footer>
        </Modal> */}

    </>
    );
};

export default BankReconciliation;
